<template>
  <b-container fluid>
    <b-alert v-model="showError" variant="danger" dismissible>
     <p>{{ error }} / {{ error_data.message }}</p>
     <ul v-for="e in error_data.errors" :key="e">
       <li>{{ e }}</li>
     </ul>
    </b-alert>

    <b-alert v-model="showAlert" variant="success" dismissible>
     <p>{{ alert_data }}</p>
    </b-alert>

    <b-row class="mt-2">
      <b-col>
        <b-link @click="filterState('done')" :class="stats.done.link_class"  v-b-tooltip.hover title="Click for filter">
        <b-card :border-variant="stats.done.border_variant" :bg-variant="stats.done.bg_variant" :text-variant="stats.done.text_variant" class="text-center">
          <template #header>
            <b-icon icon="check-circle-fill"></b-icon>
            <b>Done</b>
          </template>
          <b-card-text>
            <h3>{{ stats.done.total }}</h3>
          </b-card-text>
        </b-card>
        </b-link>
      </b-col>

      <b-col>
        <b-link @click="filterState('waiting')" :class="stats.waiting.link_class"  v-b-tooltip.hover title="Click for filter">
        <b-card :border-variant="stats.waiting.border_variant" :bg-variant="stats.waiting.bg_variant" :text-variant="stats.waiting.text_variant" class="text-center">
          <template #header>
            <b-icon icon="hourglass-split"></b-icon>
            <b>Waiting</b>
          </template>
          <b-card-text>
            <h3>{{ stats.waiting.total }}</h3>
          </b-card-text>
        </b-card>
        </b-link>
      </b-col>

      <b-col>
        <b-link @click="filterState('error')" :class="stats.error.link_class"  v-b-tooltip.hover title="Click for filter">
        <b-card :border-variant="stats.error.border_variant" :bg-variant="stats.error.bg_variant" :text-variant="stats.error.text_variant" class="text-center">
          <template #header>
            <b-icon icon="exclamation-circle-fill"></b-icon>
            <b>Error</b>
          </template>
          <b-card-text>
            <h3>{{ stats.error.total }}</h3>
          </b-card-text>
        </b-card>
        </b-link>
      </b-col>

    </b-row>

    <hr class="mt-0 mb-4">

    <b-row class="mt-2">
      <b-col class="text-center">
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>
          </b-input-group>
      </b-col>

      <b-col class="text-center">
        <b-form-group
          label="Per page:"
          label-for="per-page-select"
          label-cols-sm="6"
          label-cols-md="4"
          label-cols-lg="3"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-form-select
            id="per-page-select"
            v-model="perPage"
            :options="pageOptions"
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="mt-4">
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      stacked="md"
      show-empty
      small
      @filtered="onFiltered"
    >
            <b-icon icon="check-circle-fill"></b-icon>


      <template #cell(state)="row">
        <b-icon class="text-success" icon="check-circle-fill" v-if="row.item.state === 'done'"></b-icon>
        <b-icon class="text-warning" icon="hourglass-split" v-if="row.item.state === 'waiting'"></b-icon>
        <b-icon class="text-danger" icon="exclamation-circle-fill" v-if="row.item.state === 'error'"></b-icon>
        {{ row.item.state }}
      </template>

      <template #cell(actions)="row">
        <b-button size="sm" @click="detail(row.item, row.index, $event.target)" class="m-1">
          Detail
        </b-button>

        <b-button size="sm" @click="showDeleteMsg(row.item, row.index, $event.target)" variant="danger" class="m-1">
          Delete
        </b-button>
      </template>

    </b-table>
    </div>
    <div class="mt-4 d-flex">
    <b-pagination
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      align="fill"
      size="sm"
      class="my-0"
    ></b-pagination>
    </div>

    <b-modal class="text-left" size="lg" id="modal-detail" title="Details" ok-only>
      <b-row>
        <b-col cols="3">
          UUID:
        </b-col>
        <b-col>
            {{ detailModal.item.uuid }}
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          State:
        </b-col>
        <b-col class="">
            <b-icon class="text-success" icon="check-circle-fill" v-if="detailModal.item.state === 'done'"></b-icon>
            <b-icon class="text-warning" icon="hourglass-split" v-if="detailModal.item.state === 'waiting'"></b-icon>
            <b-icon class="text-danger" icon="exclamation-circle-fill" v-if="detailModal.item.state === 'error'"></b-icon>
            {{ detailModal.item.state }}
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3" v-b-tooltip.hover title="If message exceedes limit, the message gets split into multiple sms.">
          SMS count:
        </b-col>
        <b-col cols="">
            {{ detailModal.item.used_sms }}
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          Requester:
        </b-col>
        <b-col class="">
            {{ detailModal.item.requester_ip }}
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          Created:
        </b-col>
        <b-col class="">
            {{ detailModal.item.created_date }}
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          Retention:
        </b-col>
        <b-col>
            {{ detailModal.item.retention }} day(s)
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          Sender:
        </b-col>
        <b-col v-if="detailModal.item.sender_overwrite == false">
            {{ detailModal.item.sender }}
        </b-col>

        <b-col v-if="detailModal.item.sender_overwrite == true" v-b-tooltip.hover title="Sender was overwritten by SMS Gateway due to not allowed country code for non-nummeric sender.">
            {{ detailModal.item.sender }}
            <b-icon class="text-danger" icon="exclamation-circle-fill"></b-icon>
        </b-col>
      </b-row>

      <b-row v-if="detailModal.item.sender_overwrite == true">
        <b-col cols="3">
          Original Sender:
        </b-col>
        <b-col>
            {{ detailModal.item.sender_original }}
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          Destination:
        </b-col>
        <b-col>
            {{ detailModal.item.destination }}
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          Text:
        </b-col>
        <b-col>
            {{ detailModal.item.text }}
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          User:
        </b-col>
        <b-col>
            {{ detailModal.item.user }}
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col>
          <b-link v-b-toggle.collapse-json >Show raw json</b-link>
          <b-collapse id="collapse-json" class="mt-2">
            <b-card>
              <pre>{{ detailModal.content }}</pre>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-delete" hide-footer>
      <template #modal-title>
        Are you sure?
      </template>
      <div class="d-block text-center">
        <p>This will delete </p>
        <p>{{ deleteModal.uuid }}</p>
      </div>
      <b-button class="m-1"  @click="$bvModal.hide('modal-delete')">Cancel</b-button>
      <b-button class="m-1" variant="success" @click="deleteMsg(deleteModal.uuid)">Yes, I am sure</b-button>
    </b-modal>

  </b-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'Home',
  components: { },

  data: () => ({
    showError: false,
    error_data: '',
    error: '',
    showAlert: false,
    alert_data: '',
    detailModal: {
      id: null,
      title: null,
      content: null,
      item: {},
    },
    deleteModal: {
      uuid: null
    },
    stats: {
      filter: null,
      done: {
        total: 0,
        active: false,
        border_variant: 'success',
        bg_variant: 'white',
        text_variant: 'black',
        link_class: 'text-success nounderline'
      },
      waiting: {
        total: 0,
        active: false,
        border_variant: 'warning',
        bg_variant: 'white',
        text_variant: 'black',
        link_class: 'text-warning nounderline'
      },
      error: {
        total: 0,
        active: false,
        border_variant: 'danger',
        bg_variant: 'white',
        text_variant: 'black',
        link_class: 'text-danger nounderline'
      },
    },
    items: [],
    fields: [
      { key: 'destination', label: 'Destination', sortable: true },
      { key: 'user', label: 'User', sortable: true },
      { key: 'text', label: 'Text', sortable: true },
      { key: 'created_date', label: 'Created', sortable: true },
      { key: 'retention', label: 'Retention', sortable: true },
      { key: 'state', label: 'State', sortable: true },
      { key: 'actions', label: 'Actions' }
    ],

    totalRows: 2,
    currentPage: 1,
    perPage: 20,
    pageOptions: [10,20,50,100,1000],
    sortBy: 'created_date',
    sortDesc: true,
    sortDirection: 'desc',
    filter: null,
    filterOn: [],
  }),
  methods: {
    filterState(state) {
      this.stats.done.bg_variant = 'white'
      this.stats.done.text_variant = 'black'
      this.stats.done.text_header_variant = 'text-success'

      this.stats.waiting.bg_variant = 'white'
      this.stats.waiting.text_variant = 'black'
      this.stats.waiting.text_header_variant = 'text-warning'

      this.stats.error.bg_variant = 'white'
      this.stats.error.text_variant = 'black'
      this.stats.error.text_header_variant = 'text-danger'

      if (this.stats[state].active) {
        this.stats[state].bg_variant = 'white'
        this.stats.filter = null
        this.stats[state].active = false
        this.stats.filter = null
      } else {
        this.stats[state].text_variant = 'white'
        this.stats[state].text_header_variant = 'text-white'
        this.stats.filter = state

        if (state == 'done') {
          this.stats[state].bg_variant = 'success'
        }

        if (state == 'waiting') {
          this.stats[state].bg_variant = 'warning'
        }

        if (state == 'error') {
          this.stats[state].bg_variant = 'danger'
        }


        this.stats[state].active = true
     }

      this.getData()
    },
    showDeleteMsg(item, index, button) {
      this.deleteModal.uuid = item.uuid
      this.$bvModal.show('modal-delete')
    },
    deleteMsg(item) {
      this.$bvModal.hide('modal-delete')
      let url = process.env.BASE_URL + '/api/list/' + item
      let config = {
        headers: {
          Token: sessionStorage.getItem('token')
        }
      }

      axios.delete(url, config).then(response => {
        this.alert_data = 'Deleted item with ID ' + item
        this.showAlert = true
        this.getData()
      }).catch(err => {
        this.error = err
        this.error_data = err.response.data
        this.showError = true
      })
    },
    detail(item, index, button) {
      this.detailModal.title = `${this.getDate(item.created)}`
      this.detailModal.content = JSON.stringify(item, null, 2)
      this.detailModal.item = item
      this.$bvModal.show('modal-detail')
    },
    getDate(timestamp) {
        let date = new Date(timestamp * 1000)
        return moment(date).format("DD.MM.YYYY - HH:mm:ss");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getData() {
      let url = process.env.BASE_URL + '/api/list'
      let config = {
        headers: {
          Token: sessionStorage.getItem('token')
        }
      }

      axios.get(url, config).then(response => {
        this.items = []
        this.stats.done.total = 0
        this.stats.waiting.total = 0
        this.stats.error.total = 0

        response.data.forEach(item => {
            if (item.state === 'done') {
              this.stats.done.total += 1
            }

            if (item.state === 'waiting') {
              this.stats.waiting.total += 1
            }

            if (item.state === 'error') {
              this.stats.error.total += 1
            }

            if (this.stats.filter !== null) {
              if (item.state !== this.stats.filter) {
                return
              }
            }

            item.created_date = this.getDate(item.created)
            let log_new = []
            item.log.forEach(log_item => {
              log_item.timestamp_date = this.getDate(log_item.timestamp)
              log_new.push(log_item)
            })
            item.log = log_new
            this.items.push(item)
        })

        this.totalRows = this.items.length
      }).catch(err => {
        this.error = err
        this.error_data = err.response.data
        this.showError = true
      })
    },
  },
  mounted () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/List.vue